module.exports = __webpack_public_path__ + "static/img/app.104895b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app.png
// module id = aTzD
// module chunks = 78